import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-b border-amff-gray border-opacity-25"
}
const _hoisted_2 = {
  class: "max-w-container flex items-center py-6 px-container",
  id: "aria-thirdrow"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ml-auto" }, null, -1)
const _hoisted_4 = { class: "relative flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")
  const _component_AnchorLink = _resolveComponent("AnchorLink")

  return (_ctx.subitems)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subitems, (subitem) => {
            return (_openBlock(), _createBlock("div", {
              key: subitem.id,
              class: "ml-4 relative"
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(!subitem.children ? _ctx.AnchorLink : 'button'), {
                to: subitem.to,
                class: ["\n            rounded-xl\n            px-2\n            py-1\n            relative\n            overflow-hidden\n            hover:text-amff-teal\n            flex\n          ", 
            subitem.isSelected || subitem.isExpanded ? 'text-amff-teal' : ''
          ],
                "aria-expanded": 
            subitem.children?.length ? subitem.isExpanded : undefined
          ,
                "aria-controls": 
            subitem.children?.length ? `aria-subitem-${subitem.id}` : undefined
          ,
                onClick: ($event: any) => (subitem.children ? _ctx.expandSubitem(subitem) : null)
              }, {
                default: _withCtx(() => [
                  _createVNode("div", {
                    class: ["absolute inset-0 opacity-30 transition-all w-full", 
              subitem.isSelected ? 'bg-amff-light-teal' : 'bg-transparent'
            ]
                  }, null, 2),
                  _createVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.$t(subitem.text)) + " ", 1),
                    (subitem.children?.length)
                      ? (_openBlock(), _createBlock(_component_ChevronIcon, {
                          key: 0,
                          class: "ml-2 w-3 h-3 text-amff-teal transition-transform",
                          fill: "currentColor",
                          style: 
                subitem.isExpanded
                  ? 'transform: rotate(180deg)'
                  : 'transform: rotate(0deg)'
              
                        }, null, 8, ["style"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["to", "class", "aria-expanded", "aria-controls", "onClick"])),
              (subitem.isExpanded && subitem.children?.length)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    id: `aria-subitem-${subitem.id}`,
                    class: "\n            absolute\n            top-0\n            left-0\n            mt-8\n            z-30\n            bg-amff-teal\n            text-amff-black\n            shadow-lg\n          "
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(subitem.children, (subsubitem) => {
                      return (_openBlock(), _createBlock(_component_AnchorLink, {
                        key: subsubitem.text,
                        class: "\n              block\n              p-4\n              w-52\n              border-b border-amff-black\n              hover:bg-amff-black\n              hover:text-amff-teal\n            ",
                        to: subsubitem.to,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandSubitem(null) /* closes dropdown */))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(subsubitem.text)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ], 8, ["id"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}